import React, { useEffect, useState } from "react";

const SectionPagination = ({
  total,
  count,
  limit,
  total_pages,
  setCurrentPosts,
}) => {
  const [pages, setPages] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    setPages(
      Array.from(
        { length: total_pages ? total_pages : 0 },
        (_, index) => index + 1
      )
    );
  }, [total_pages]);

  useEffect(() => {
    generateRequest(currentPage);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  function generateRequest(page) {
    setCurrentPosts(page);
  }

  return (
    <div className="pagination-container">
      {count > 0 && limit > 0 && total > 0 ? (
        <>
          <a
            href={`?page=${currentPage > 1 ? currentPage - 1 : currentPage}`}
            className="pagination-button"
            onClick={(e) => {
              e.preventDefault();
              if (currentPage > 1) {
                setCurrentPage(currentPage - 1);
              }
            }}
          >
            {"<<"}
          </a>
          <div className="pagination-pages">
            {pages.map((page) => {
              if (page < 3 || page === currentPage) {
                return (
                  <a
                    key={page}
                    href={`?page=${page}`}
                    className={`pagination-button ${
                      currentPage === page ? "active" : ""
                    }`}
                    onClick={(e) => {
                      e.preventDefault();
                      setCurrentPage(page);
                    }}
                  >
                    {page}
                  </a>
                );
              } else if (
                page === currentPage + 1 ||
                page === currentPage - 1 ||
                page === currentPage
              ) {
                return (
                  <a
                    key={page}
                    href={`?page=${page}`}
                    className={`pagination-button ${
                      page === currentPage ? "active" : ""
                    }`}
                    onClick={(e) => {
                      e.preventDefault();
                      setCurrentPage(page);
                    }}
                  >
                    {page}
                  </a>
                );
              } else if (page === pages.length) {
                return (
                  <a
                    key={page}
                    href={`?page=${total_pages}`}
                    className={`pagination-button ${
                      currentPage === page ? "active" : ""
                    }`}
                    onClick={(e) => {
                      e.preventDefault();
                      setCurrentPage(total_pages);
                    }}
                  >
                    {total_pages}
                  </a>
                );
              } else {
                return (
                  <span key={page} className="dots">
                    .
                  </span>
                );
              }
            })}
          </div>
          <a
            href={`?page=${
              currentPage < total_pages ? currentPage + 1 : total_pages
            }`}
            className="pagination-button"
            onClick={(e) => {
              e.preventDefault();
              if (currentPage < total_pages) {
                setCurrentPage(currentPage + 1);
              }
            }}
          >
            {">>"}
          </a>
        </>
      ) : null}
    </div>
  );
};

export default SectionPagination;
